export default class ApiError extends Error {
	constructor(error) {
		super(error);
		this.name = error.name;
		this.message = error.message;
		Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
	}
}
